<div *ngIf="type == 2" class="trial-message-header">
     <span>{{trialExpiredMessage}}</span>
</div>